import { render } from "./edittravel.vue?vue&type=template&id=41aa2312&scoped=true"
import script from "./edittravel.vue?vue&type=script&lang=js"
export * from "./edittravel.vue?vue&type=script&lang=js"

import "./edittravel.vue?vue&type=style&index=0&id=41aa2312&lang=scss&scoped=true"
import "./edittravel.vue?vue&type=style&index=1&id=41aa2312&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mac\\Downloads\\PCguanli\\zhongtaiworkPC\\yungong_1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41aa2312"]])

export default __exports__